<template>
	<div>
		<el-button @click="btnClick"><img style="width: 12px; height:12px;margin-right:5px" v-if="btn.btnIcon"
				:src="btn.btnIcon">{{btn.btnLabel}}</el-button>
		<el-dialog :title="btn.title" :center="true" :visible.sync="dialog" :append-to-body="true"
			:close-on-click-modal="false" width="550px" custom-class="dialog-style">
			<div class="dialog-content">
				<el-form ref="form" :model="btn" label-width="150px">
					<el-form-item v-for="(item,index) in btn.columnList" :label="item.columnLabel" :key="index">
						<template v-if="item.columnType  === 0">
							<el-input :ref="item.column" v-model="item.value"></el-input>
						</template>
						<template v-if="item.columnType  === 1">
							<el-select :ref="item.column" v-model="item.value" placeholder="请选择">
								<el-option v-for="(item1,index1) in item.columnTermList" :label="item1.name"
									:value="item1.id" :key="index1"></el-option>
							</el-select>
						</template>
						<template v-if="item.columnType  === 2">
							<el-radio-group :ref="item.column" v-model="item.value">
								<el-radio v-for="(item1,index1) in item.columnTermList" :label="item1.id" :key="index1">
									{{item1.name}}
								</el-radio>
							</el-radio-group>
						</template>
						<template v-if="item.columnType  === 3">
							<el-checkbox-group :ref="item.column" v-model="item.value">
								<el-checkbox v-for="(item1,index1) in item.columnTermList" :label="item1.id"
									:key="index1">
									{{item1.name}}
								</el-checkbox>
							</el-checkbox-group>
						</template>
						<template v-if="item.columnType  === 4">
							<el-upload :ref="item.column" class="avatar-uploader" action="#" :show-file-list="false"
								:http-request="upload">
								<img v-if="item.value" :src="item.value" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</template>
						<template v-if="item.columnType  === 5">
							<el-date-picker v-model="item.value" type="date" placeholder="选择日期" style="width: 100%;"
								value-format="yyyy-MM-dd">
							</el-date-picker>
						</template>
						<template v-if="item.columnType  === 7">
							<el-time-picker v-model="item.value" placeholder="选择时间" style="width: 100%;"
								value-format="HH:mm" format="HH:mm">
							</el-time-picker>
						</template>
						<template v-if="item.columnType  === 6">
							<el-select :ref="item.column" v-model="item.value" placeholder="请选择" @change="item.areaFun">
								<el-option v-for="(item1,index1) in item.columnTermList" :label="item1.name"
									:value="item1.areaCode" :key="index1"></el-option>
							</el-select>
						</template>
						<template v-if="item.columnType  === 8">
							<el-autocomplete class="inline-input" v-model="item.value" :ref="item.column"
								:fetch-suggestions="item.InputFun" placeholder="请输入内容" @select="item.selectFun"
								:value-key="item.valueKey"></el-autocomplete>
						</template>
						<template v-if="item.columnType  === 9">
							<el-checkbox-group v-model="MenuDataList" style="width: 310px">
								<template v-for="(itemMenu,index) in MenuList">
									<div style="border-bottom: 1px dashed #dedede">
										<el-checkbox :label="itemMenu.menu" :key="itemMenu.menu"
											@change="firstPermChanged(index)">{{itemMenu.menuName}}</el-checkbox>
										<div style="margin-left: 20px">
											<template v-for="(itemSubmenu,index2) in itemMenu.subclass">
												<el-checkbox :label="itemSubmenu.menu" :key="itemSubmenu.menu"
													@change="secondPermChanged(index,index2)">{{itemSubmenu.menuName}}
												</el-checkbox>
												<div style="margin-left: 20px">
													<template v-for="(itemBtn,index3) in itemSubmenu.subclass">
														<el-checkbox :label="itemBtn.menu" :key="itemBtn.menu"
															@change="thirdPermChanged(index,index2,index3)">
															{{itemBtn.menuName}}
														</el-checkbox>
													</template>
												</div>
											</template>
										</div>
									</div>
								</template>
							</el-checkbox-group>
						</template>
						<template v-if="item.columnType  === 10">
							<el-select :ref="item.column" multiple collapse-tags v-model="item.value" placeholder="请选择">
								<el-option v-for="(item1,index1) in item.columnTermList" :label="item1.name"
									:value="item1.name" :key="index1"></el-option>
							</el-select>
						</template>
						<template v-if="item.columnType  === 11">
							<el-date-picker v-model="item.value" type="month" placeholder="选择日期" style="width: 100%;"
								value-format="yyyy-MM">
							</el-date-picker>
						</template>
            <template v-if="item.columnType  === 12">
            	<el-switch v-model="item.value"  :active-text="item.toptitle"
            		:inactive-text="item.downtitle">
            	</el-switch>
            </template>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialog = false">取 消</el-button>
				<el-button type="primary" @click="onSubmit()">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import menuJs from "@/assets/js/system/menu.js";
	export default {
		name: "btnAdd",
		props: {
			btn: {
				type: Object,
				default: {}
			},
		},
		data: function() {
			return {
				dialog: false,
				MenuDataList: [],
				MenuList: [],
			}
		},
		/* computed: {
		}, */
		methods: {
			btnClick() {
				var $this = this;
				this.btn.btnClick(function() {
					$this.dialog = true;
					$this.MenuDataList = []
				});
			},
			upload(res) {
				var $this = this;
				this.btn.columnList.forEach(function(item, index) {
					if (item.columnType == 4) {
						$this.convertImgToBase64(res.file, base64Str => item.value = base64Str,
							error => console.log(error))
					}
				})
			},
			convertImgToBase64(imageFile, callback, errorCallback) {
				try {
					let reader = new FileReader()
					reader.readAsDataURL(imageFile)
					reader.onload = function(e) {
						if (callback) {
							let base64Str = e.target.result
							callback(base64Str)
						}
					}
				} catch (error) {
					console.error(error)
					if (errorCallback) {
						errorCallback(error)
					}
				}
			},
			onSubmit() {
				var $this = this;
				var add = {};
				this.btn.columnList.forEach(function(item, index) {
					if (item.columnType == "9") {
						add[item.column] = $this.MenuDataList;
					} else {
						add[item.column] = item.value;
					}
				})
				this.btn.btnFun(function() {
					$this.dialog = false;
				}, add);
			},
			// 判断数组中是否包含Id
			find: function(id) {
				var isCheckAll = false;
				for (var i = 0; i < this.MenuDataList.length; i++) {
					if (this.MenuDataList[i] == id) {
						isCheckAll = true;
					}
				}
				return isCheckAll;
			},
			// 删除数组中的元素
			removeByValue: function(arr, val) {
				for (var i = 0; i < arr.length; i++) {
					if (arr[i] == val) {
						arr.splice(i, 1);
						break;
					}
				}
			},
			// 点击一级权限
			firstPermChanged: function(index) {
				var firstPerm = this.MenuList[index];
				var isCheck = this.find(firstPerm.menu);
				// 一级权限是否选中
				if (isCheck) {
					if (firstPerm.subclass != "" && firstPerm.subclass != undefined) {
						for (var j = 0; j < firstPerm.subclass.length; j++) {
							// 添加所有的二级权限
							this.MenuDataList.push(firstPerm.subclass[j].menu);
							if (firstPerm.subclass[j].subclass != "" && firstPerm.subclass[j].subclass != undefined) {
								for (var k = 0; k < firstPerm.subclass[j].subclass.length; k++) {
									// 添加所有的三级权限
									this.MenuDataList.push(firstPerm.subclass[j].subclass[k].menu);
								}
							}
						}
					}
				} else {
					if (firstPerm.subclass != "" && firstPerm.subclass != undefined) {
						for (var j = 0; j < firstPerm.subclass.length; j++) {
							// 删除所有二级权限
							this.removeByValue(this.MenuDataList, firstPerm.subclass[j].menu);
							if (firstPerm.subclass[j].subclass != "" && firstPerm.subclass[j].subclass != undefined) {
								for (var k = 0; k < firstPerm.subclass[j].subclass.length; k++) {
									// 删除所有三级权限
									this.removeByValue(this.MenuDataList, firstPerm.subclass[j].subclass[k].menu);
								}
							}
						}
					}
				}
			},
			// 点击二级权限
			secondPermChanged: function(index, index2) {
				var firstPerm = this.MenuList[index];
				var secondPerm = this.MenuList[index].subclass[index2];
				var isSecondCheck = this.find(secondPerm.menu); // 二级权限是否选中
				if (isSecondCheck) {
					// 添加一级权限
					if (!this.find(firstPerm.menu)) {
						this.MenuDataList.push(firstPerm.menu);
					}
					if (secondPerm.subclass != "" && secondPerm.subclass != undefined) {
						for (var j = 0; j < secondPerm.subclass.length; j++) {
							// 添加二级权限的三级权限
							this.MenuDataList.push(secondPerm.subclass[j].menu);
						}
					}
				} else {
					// 删除二级权限的三级权限
					if (secondPerm.subclass != "" && secondPerm.subclass != undefined) {
						for (var j = 0; j < secondPerm.subclass.length; j++) {
							this.removeByValue(this.MenuDataList, secondPerm.subclass[j].menu);
						}
					}
					// 判断二级权限是否有兄弟选中
					var isSiblingsCheck = false;
					if (firstPerm.subclass != "" && firstPerm.subclass != undefined) {
						for (var i = 0; i < firstPerm.subclass.length; i++) {
							if (this.find(firstPerm.subclass[i].menu)) {
								isSiblingsCheck = true;
								break;
							}
						}
					}
					// 如果没有，就删除一级权限
					// if (!isSiblingsCheck) {
					// 	this.removeByValue(this.MenuDataList, firstPerm.menu);
					// }
				}
			},
			// 点击三级权限
			thirdPermChanged: function(index, index2, index3) {
				var firstPerm = this.MenuList[index];
				var secondPerm = firstPerm.subclass[index2];
				var thirdPerm = secondPerm.subclass[index3];
				var isThirdCheck = this.find(thirdPerm.menu);
				// 判断三级权限是否被选中
				if (isThirdCheck) {
					// 添加前需要判断是否已存在
					// 添加一级权限
					if (!this.find(firstPerm.menu)) {
						this.MenuDataList.push(firstPerm.menu);
					}
					// 添加二级权限
					if (!this.find(secondPerm.menu)) {
						this.MenuDataList.push(secondPerm.menu);
					}
				} else {
					// 判断三级权限的兄弟是否被选中
					// var isSiblingsCheck = false;
					// if (secondPerm.subclass != "" && secondPerm.subclass != undefined) {
					// 	for (var i = 0; i < secondPerm.subclass.length; i++) {
					// 		if (this.find(secondPerm.subclass[i].menu)) {
					// 			isSiblingsCheck = true;
					// 			break;
					// 		}
					// 	}
					// }
					// if (!isSiblingsCheck) {
					// 删除二级权限
					// this.removeByValue(this.MenuDataList, secondPerm.menu);
					// 判断二级权限的兄弟是否被选中
					// var isThirdSiblingsCheck = false;
					// if (firstPerm.subclass != "" && firstPerm.subclass != undefined) {
					// 	for (var i = 0; i < firstPerm.subclass.length; i++) {
					// 		if (this.find(firstPerm.subclass[i].menu)) {
					// 			isThirdSiblingsCheck = true;
					// 			break;
					// 		}
					// 	}
					// }
					// 如果没有，删除一级权限
					// if (!isThirdSiblingsCheck) {
					// 	this.removeByValue(this.MenuDataList, firstPerm.menu);
					// }
					// }
				}
			}
		},
		mounted() {
			this.MenuList = menuJs.getMenuList();
		}
	};
</script>
<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.dialog-content .el-form-item__content {
		line-height: 40px;
		position: relative;
		font-size: 14px;
		width: 220px;
	}

	.dialog-content .el-checkbox {
		margin-right: 10px;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/button/btnAdd.vue